export const HandleError = (error) => {
    if (error.response) {
        const status = error.response.status;
        console.log("response", error.response);
        console.log("status", status);
        switch (status) {
            case 401: {
                localStorage.removeItem('token');
                window.location.href = '/log-in';
                break;
            }
            default:
                break;
        }
    }
};